'use es6';

import get from 'transmute/get';
import getIn from 'transmute/getIn';
import setIn from 'transmute/setIn';
import { createSelector } from 'reselect';
import { getStagedFormState, getFormFields } from 'MeetingsLib/selectors/FormFieldValidationSelector';
import { getPublicAvailabilityInfoFetchStatus } from 'MeetingsLib/selectors/RequestStatusSelectors';
import { STARTED, SUCCEEDED } from 'MeetingsBase/constants/RequestStatusTypes';
import { getAdminDomain, getLinkEditParam } from 'MeetingsLib/utils/utils';
import { START_TIME_INTERVALS, START_TIME_INTERVAL_VALUES } from 'MeetingsBase/constants/enums';
import { MINUTES_TO_MILLIS } from 'MeetingsBase/constants/dates';

var getProfileFromProps = function getProfileFromProps(state, props) {
  return get('profile', props);
};

var getProfileFromState = get('profile');
var getRoundRobinProfile = getIn(['bookingLifecycle', 'postResponse', 'organizer']);
var getForceOffline = get('forceOffline');
var getPortalId = get('portalId');
var getOpenGates = getIn(['bookInfo', 'openGates']);
export var getUserProfile = createSelector([getProfileFromProps, getProfileFromState, getRoundRobinProfile], function (propsProfile, stateProfile, roundRobinProfile) {
  return propsProfile || roundRobinProfile || stateProfile;
});
export var getIsUngatedForLinkAvailability = createSelector([getOpenGates], function (openGates) {
  return openGates.includes('Meetings:LinkAvailability');
});
export var shouldFetchAvailability = createSelector([getPublicAvailabilityInfoFetchStatus], function (availabilityInfoFetchStatus) {
  return availabilityInfoFetchStatus !== STARTED && availabilityInfoFetchStatus !== SUCCEEDED;
});

var getDisplayInfoProp = function getDisplayInfoProp(props) {
  return get('displayInfo', props);
};

var getDisplayInfoState = getIn(['bookInfo', 'customParams', 'displayInfo']);
export var getDisplayInfo = function getDisplayInfo(state, props) {
  var propDisplayInfo = getDisplayInfoProp(props);
  var stateDisplayInfo = getDisplayInfoState(state);
  return propDisplayInfo || stateDisplayInfo;
};
var getWelcomeScreenInfoState = getIn(['bookInfo', 'customParams', 'welcomeScreenInfo']);
export var getWelcomeScreenInfo = function getWelcomeScreenInfo(state) {
  return getWelcomeScreenInfoState(state);
};
export var getLocaleFromSettings = getIn(['bookInfo', 'customParams', 'locale']);
export var getLanguageFromSettings = getIn(['bookInfo', 'customParams', 'language']);
var getBookingLifecycle = get('bookingLifecycle');
var getBookInfoState = get('bookInfo');
export var getUserTimezone = get('userTimezone');
export var getEvent = createSelector([getBookingLifecycle], function (bookingLifecycle) {
  return bookingLifecycle.event;
});
export var getMeetingLength = createSelector([getEvent], function (event) {
  return event.duration;
});
export var getBookInfo = createSelector([getBookInfoState, getDisplayInfo], function (stateBookInfo, displayInfo) {
  if (stateBookInfo) {
    return setIn(['customParams', 'displayInfo'], displayInfo, stateBookInfo);
  }

  return stateBookInfo;
});
export var getEditLinkURL = createSelector([getBookInfo, getPortalId], function (bookInfo, portalId) {
  var linkId = bookInfo.linkId,
      linkType = bookInfo.linkType;
  var linkEditParam = getLinkEditParam(linkType);
  var baseURL = getAdminDomain();
  return baseURL + "/meetings/" + portalId + "/" + linkEditParam + "/" + linkId;
});
export var getCustomParams = createSelector([getBookInfo], function (bookInfo) {
  return get('customParams', bookInfo);
});
export var getRecaptchaEnabled = createSelector([getCustomParams, getOpenGates], function (customParams, openGates) {
  return get('recaptchaEnabled', customParams) && openGates.includes('Meetings:RecaptchaEnabled');
});
export var getLegalConsentEnabled = createSelector([getCustomParams], function (customParams) {
  return get('legalConsentEnabled', customParams);
});
export var getLegalConsentOptions = createSelector([getCustomParams], function (customParams) {
  return get('legalConsentOptions', customParams);
});
export var getIsLegitimateInterest = createSelector([getLegalConsentOptions], function (legalConsentOptions) {
  return get('isLegitimateInterest', legalConsentOptions);
});
export var getStartTimeIncrementMinutes = createSelector([getCustomParams], function (customParams) {
  return get('startTimeIncrementMinutes', customParams);
});
export var getStartTimeIntervalMilliseconds = createSelector([getStartTimeIncrementMinutes, getEvent], function (startTimeIncrementMinutes, event) {
  var startTimeMinuteValue = START_TIME_INTERVAL_VALUES[startTimeIncrementMinutes];
  return startTimeMinuteValue === START_TIME_INTERVALS.MEETING_DURATION ? event.duration : startTimeMinuteValue * MINUTES_TO_MILLIS;
});
export var getOffline = createSelector([getBookInfo, getForceOffline], function (bookInfo, forceOffline) {
  return forceOffline || bookInfo.offline;
});
export var getShouldAutoSubmit = getIn(['bookInfo', 'customParams', 'shouldAutoSubmit']);
/* TODO: We will need to include welcomeScreenInfo.showWelcomeScreen after old links are backfilled
  Issue: https://zenhub.hubteam.com/workspaces/sales-meetings-5faac280584ad5090d10613a/issues/hubspot/sales-meetings/55
*/

export var shouldShowEmailForm = createSelector([getBookInfo, getStagedFormState, getShouldAutoSubmit], function (bookInfo, stagedFormState, shouldAutoSubmit) {
  return get('ownerPrioritized', bookInfo) && stagedFormState && (!stagedFormState.email || !shouldAutoSubmit);
});
export var shouldCenterPropertyForm = createSelector([getFormFields], function (formFields) {
  return formFields.isEmpty();
});